import SessionContent from './SessionContent';

export default SessionContent;
